import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Box, Grid, IconButton } from '@mui/material';
import ProfileSection from './ProfileSection';
import { drawerWidth } from '../../../config';
import MenuIcon from '@mui/icons-material/Menu';

const Header = ({ drawerToggle }) => {
  const theme = useTheme();
  return (
    <>
      <Box width={drawerWidth}>
        <Grid container justifyContent="space-between" alignItems="center">
          
          <Grid item>
            <IconButton
              edge="start"
              sx={{ mr: theme.spacing(1.25) }}
              color="inherit"
              aria-label="open drawer"
              onClick={drawerToggle}
              size="small"
            >
              <MenuIcon sx={{ fontSize: '1.5rem' }} />
            </IconButton>
          </Grid>
          <Box sx={{ display: { xs: 'none', md: 'block' } }}>
            <Grid item>
              <Box mt={0.5}>
                <h3>RDCx Configuration Tool</h3>
              </Box>
            </Grid>
          </Box>
        </Grid>
      </Box>
      <Box sx={{ flexGrow: 1 }} />
      <ProfileSection />
    </>
  );
};


export default Header;
